import { Check } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";

// ONE ✓, ONE VALUE (his rule): every number, option and extra a reader put on the truck is checked
// on its own — there is no "check all" for them anywhere.
export const AiValueTick = ({ donorId, kind, item, component = "", canEdit, onDone, testid }) => {
  if (item.verified_by) {
    return (
      <span data-testid={`${testid}-checked`} title={`Checked by ${item.verified_by}`} className="text-emerald-600 inline-flex">
        <Check className="w-3 h-3" />
      </span>
    );
  }
  if (!canEdit || item.source === "manual") return null;
  const tick = async (e) => {
    e.stopPropagation();
    try {
      await api.post(`/donors/${donorId}/ai-values/verify`, {
        kind, component, label: item.label || "", value: item.value != null ? String(item.value) : "",
        code: item.code || "", description: item.description || "",
      });
      toast.success("Checked");
      onDone?.();
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "That could not be checked.");
    }
  };
  return (
    <button type="button" data-testid={`${testid}-verify`} onClick={tick} title="I have checked this one value against the sheet"
      className="text-[10px] font-semibold text-emerald-700 hover:bg-emerald-50 border border-emerald-200 rounded px-1 leading-4 transition-colors">
      ✓verify
    </button>
  );
};
